module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com.c653feed.svg";